/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Divider, Typography, Button, Paper, TextField, FormControl, OutlinedInput, InputLabel, IconButton, Slider, Collapse, Tooltip  } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Add, Delete, ExpandLess, ExpandMore } from '@material-ui/icons'

import FlexForm from '../../FlexForm/FlexForm'
import components from '../../FlexForm/Elements/Components/Components'

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({
    field : {
        boxSizing: 'border-box', 
        margin : '1%', 
        width : '48%'
    }
})

const marks = [
    {
        value : 50,
        label : '50%'
    }
]

class Field extends Component {
    state = {
        show_params : false
    }

    renderDelete = () => {
        return (
            <Tooltip title = "Delete Field">
                <IconButton size = 'small' color = 'secondary' onClick = {() => this.props.delete(this.props.field.id)}>
                    <Delete fontSize = 'small'/>
                </IconButton>
            </Tooltip>
        )
    }

    renderExpand = () => {
        return (
            <Tooltip title = {this.state.show_params ? "Hide Params" : "Show Params"}>
                <IconButton size = 'small' onClick = {() => this.setState({...this.state.form_config, show_params : !this.state.show_params})}>
                    {this.state.show_params ? <ExpandLess fontSize = 'small'/> : <ExpandMore fontSize = 'small'/>}
                </IconButton>
            </Tooltip>
        )
    }

    render() { 
        console.log("Props Field : ", this.props.field)
        const { classes } = this.props
        return (
            <Paper style = {{width : '100%', padding : '5px', marginBottom : '10px'}}>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
                        <div style = {{width : '95%', display: 'flex', flexDirection : 'row', flexWrap : 'wrap'}}>
                            <FormControl className = {classes.field} size = 'small' label = 'Label'>
                                <OutlinedInput
                                    placeholder = "Field Label"
                                    color = 'primary'
                                    value = {this.props.field.name}
                                    onChange = {(event) => this.props.update_field(this.props.field.id, "name", event.target.value)}
                                />
                            </FormControl>
                            <Autocomplete
                                className = {classes.field}
                                color = 'primary'
                                id="style"
                                options={this.props.components}
                                getOptionLabel={(option) => option.annotation}
                                value = {this.props.field.type}
                                onChange={(event, newValue) => {
                                    this.setState({...this.state, show_params : true})
                                    this.props.update_field(this.props.field.id, "component", newValue.type)
                                }}
                                renderInput={(params) => <TextField {...params} label="Type" size = 'small' variant="outlined" />}
                            />
                            {/* <FormControl className = {classes.field} size = 'small' label = 'Label'>
                                <Typography variant = 'caption'>Width (%)</Typography>
                                <Slider
                                    style = {{marginLeft : '1%', marginRight : '1%', width : '98%'}}
                                    defaultValue={50}
                                    aria-labelledby="discrete-slider"
                                    valueLabelDisplay="auto"
                                    step={5}
                                    min={10}
                                    value = {this.props.field.component_params.findIndex(param => param.name === 'width') !== -1 ? this.props.field.component_params.find(param => param.name === 'width').value.number : 50}
                                    max={100}
                                    onChange = {(event, newValue) => {
                                        this.props.update_param(this.props.field.id, "width", newValue, "number")
                                    }}
                                    disabled = {this.props.field.component === null ? true : false}
                                    marks = {marks}
                                />
                            </FormControl> */}
                            {/* <Autocomplete
                                className = {classes.field}
                                color = 'primary'
                                id="style"
                                options={this.props.binding_keys}
                                value = {this.props.field.component_params.findIndex(param => param.name === 'binding_key') !== -1 ? this.props.field.component_params.find(param => param.name === 'binding_key').value.text : null}
                                onChange={(event, newValue) => {
                                    this.props.update_param(this.props.field.id, "binding_key", newValue, "text")
                                }}
                                renderInput={(params) => <TextField {...params} label="Source Field" size = 'small' variant="outlined" />}
                            /> */}
                        </div>
                        <div style = {{width : '5%', display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                            <div style = {{flexGrow : 1}}>
                                {this.renderDelete()}
                            </div>
                            {this.renderExpand()}
                        </div>
                    </div>
                    <Collapse in = {this.state.show_params}>
                        <div>
                            <Typography variant = 'overline'>Parameters</Typography>
                            <Divider style = {{marginBottom : '5px'}}/>
                            <FlexForm
                                key = {this.props.field.id}
                                //config = {components.findIndex(comp => comp.type === this.props.field.component) !== -1 ? components.find(comp => comp.type === this.props.field.component).setup_form : []} 
                                config = {components.findIndex(comp => comp.type === this.props.field.component) !== -1 ? this.props.field.component_params : []} 
                                fields_in_scope = {this.props.binding_keys} 
                                update_parent = {(form) => this.props.refresh_params(this.props.field.id, form)} 
                                submit = {(form) =>  null} 
                                grid_element_width = "32%"
                            />
                        </div>
                    </Collapse>
                </Paper>
        );
    }
}
 
export default withStyles(styles)(Field);